module.exports = __webpack_public_path__ + "img/bg_espace_rc.225069da.jpg";